import { GetServerSideProps, NextPage } from "next"

export const getServerSideProps: GetServerSideProps = async context => {
  return {
    redirect: {
      destination: `/search/photo`,
      permanent: true,
    },
  }
}

const DefaultSearchPage: NextPage = () => {
  return null
}

export default DefaultSearchPage
